import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from '../../styles/IceCream/1ChooseFrame.module.css';
import '../../styles/IceCream/IceCream.css';

function FrameSelectionIceCream() {
  const navigate = useNavigate();
  const [selectedFrame, setSelectedFrame] = useState(null);

  const frameOptions = [
    { id: 'theme1', name: 'THEME 1', frameImage: '/img/IceCream/Theme1.PNG' },
    { id: 'theme2', name: 'THEME 2', frameImage: '/img/IceCream/Theme2.PNG' },
    { id: 'theme3', name: 'THEME 3', frameImage: '/img/IceCream/Theme3.PNG' },
  ];

  const handleFrameSelect = (frame) => setSelectedFrame(frame);

  const handleContinue = () => {
    if (selectedFrame) {
      navigate('/icecream/photobooth', {
        state: { selectedFrame }
      });
    }
  };

  return (
    <div className="IceCreamBg" style={{ backgroundImage: "url('/img/IceCream/Background.PNG')" }}>
      <div className={styles['frame-selection-container']}>
        <Link to="/icecream" className={styles['frame-back-link']}>
          ← Back to Home
        </Link>

        <h2 className={styles['frame-selection-title']}>
          Please choose a frame
        </h2>

        <div className={styles['frame-selection-grid']}>
          {frameOptions.map((frame) => (
            <div key={frame.id} className={styles['frame-container']}>
              <div
                className={`${styles['frame-option']} ${selectedFrame?.id === frame.id ? styles['selected'] : ''}`}
                onClick={() => handleFrameSelect(frame)}
              >
                <div className={styles['frame-image-container']}>
                  <img
                    src={frame.frameImage}
                    alt={frame.name}
                    className={styles['frame-image']}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className={styles['frame-fallback']} style={{ display: 'none' }}>
                    {frame.name}
                  </div>
                </div>
              </div>
              <div className={styles['frame-name']}>{frame.name}</div>
            </div>
          ))}
        </div>

        <div className={styles['frame-continue-section']}>
          <button
            onClick={handleContinue}
            disabled={!selectedFrame}
            className={styles['frame-continue-button']}
          >
            Next &gt;
          </button>
        </div>
      </div>
    </div>
  );
}

export default FrameSelectionIceCream;
